export default __webpack_public_path__ + "static/media/parkhub.43601d08.png";